module.exports = __webpack_public_path__ + "img/reserve.fa336e4b.png";